import React from 'react';
import { BlockToolbarButtonProps, ToolbarButton } from '@udecode/plate';
import { focusEditor, someNode, useEventPlateId, usePlateEditorState } from '@udecode/plate-common';

export const AddMemoryToolbarButton = ({ id, type, active: _active, ...props }: BlockToolbarButtonProps) => {
  const editor = usePlateEditorState(useEventPlateId(id));
  const active = _active ?? (!!editor?.selection && someNode(editor, { match: { type } }));

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    editor.insertText('/');
    focusEditor(editor);
  };

  return <ToolbarButton active={active} onClick={handleClick} {...props} />;
};
